import Vue from "vue";
export default Vue.extend({
    props: {
        status: {
            type: Object,
            required: true,
        },
    },
});
